import { useState, useEffect } from "react";
import {
  fetchDistricts,
  fetchConstituencies,
  fetchPollingDivisions,
  fetchRegistrationCentres,
  fetchPollingStations,
  fetchElectionResults,
} from "../services/api";
import { Dropdown } from 'primereact/dropdown';

export default function Dropdowns({ events, selectedEvent, onSelectEvent, onResults, stateChange = () => { } }) {
  const [districts, setDistricts] = useState([]);
  const [constituencies, setConstituencies] = useState([]);
  const [pollingDivisions, setPollingDivisions] = useState([]);
  const [registrationCentres, setRegistrationCentres] = useState([]);
  const [pollingStations, setPollingStations] = useState([]);
  const [change, setChange] = useState(true);

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedConstituency, setSelectedConstituency] = useState("");
  const [selectedPollingDivision, setSelectedPollingDivision] = useState("");
  const [selectedRegistrationCentre, setSelectedRegistrationCentre] = useState("");
  const [selectedPollingStation, setSelectedPollingStation] = useState("");


  useEffect(() => {
    stateChange(change)
  }, [change])

  useEffect(() => {
    // whenever the selectedEvent changes, reset everything and load districts
    async function loadDistricts() {
      setDistricts([]);
      setConstituencies([]);
      setPollingDivisions([]);
      setRegistrationCentres([]);
      setPollingStations([]);

      setSelectedDistrict("");
      setSelectedConstituency("");
      setSelectedPollingDivision("");
      setSelectedRegistrationCentre("");
      setSelectedPollingStation("");

      if (!selectedEvent) return;
      try {
        const d = await fetchDistricts(selectedEvent);
        setDistricts(d || []);
      } catch (err) {
        console.error("Failed to load districts:", err);
      }
    }
    loadDistricts();
  }, [selectedEvent]);



  return (
    <div className="grid">
      <div className="col-12">
        <label className="text-gray-900 mb-2">Select Event {<span style={{ color: "red" }}>*</span>}</label>
        <Dropdown className="w-full" optionValue="eventID" optionLabel="name" value={selectedEvent} onChange={(e) => onSelectEvent(e.value)} options={events}
          placeholder="Select" />
      </div>
    </div>
  );
}
